export default __webpack_public_path__ + "static/porosity-39c09cd45d104e3dfa5583c917975fbb.png";